import PropTypes from "prop-types";
import cn from "classnames";
import { useState } from "react";
import { useInView } from "react-intersection-observer";
import Navbar from "components/shared/residencies/Navbar";
import Panel from "components/residency/Panel";
import PanelAvailability from "components/event/PanelAvailability";
import styles from "components/event/Navigation.module.scss";

export default function Navigation({
  departures,
  navbarDark = false,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const [navbarRef, navbarInView] = useInView({
    threshold: 0,
    initialInView: true,
  });

  return (
    <>
      <div className={styles.navbarWrapper} ref={navbarRef}>
        <Navbar
          parentName="Home"
          parentPath="/"
          className={cn(navbarDark && styles.navbarDark, styles.navbar)}
        />
      </div>
      <div
        className={cn(
          styles.actions,
          navbarInView ? styles.actionsHidden : styles.actionsVisible
        )}
      >
        <button
          type="button"
          className={styles.action}
          onClick={() => toggleOpen("form")}
        >
          Book your spot
        </button>
      </div>
      <Panel isOpen={isOpen} setIsOpen={setIsOpen}>
        <PanelAvailability
          departures={departures}
        />
      </Panel>
    </>
  );
}

Navigation.propTypes = {
  departures: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      start_date: PropTypes.string,
      end_date: PropTypes.string,
      total_quantity: PropTypes.number,
      quantity_available: PropTypes.number,
    })
  ),
  navbarDark: PropTypes.bool,
};
